module.exports = __webpack_public_path__ + "media/images/tick-44e68a614757cbc2c8ffb011b6a17d87.png";